import { render, staticRenderFns } from "./ExamPlaceSlidebar.vue?vue&type=template&id=4510ddea"
import script from "./ExamPlaceSlidebar.vue?vue&type=script&lang=js"
export * from "./ExamPlaceSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports